// @flow

import * as React from 'react';

import { T } from 'components/translation';

import style from './extension-content-overview.module.scss';

type Props = {
  extension: Extension,
};

export const ExtensionContentOverview = ({ extension }: Props) => (
  <>
    <h3 className={style.ExtensionContentHeader}>
      Overview
    </h3>
    {/* Translation markers - not rendered */}
    <div style={{ display: 'none' }}>
      <T
        _str="Overview"
        _comment="Section header for an extension details page."
      />
    </div>
    <div className={style.ExtensionContentBody}>
      {extension.overview}
    </div>
  </>
);
